
import React, { useState, useRef, useEffect } from "react";
import { Box, Card, TextField, Grid, Typography, Button } from "@mui/material";
import ButtonComponent from "../Reusable/PrimaryButton/PrimaryButton";
import promptMessage from "../../assets/promptMessage.png"
import './Studio.css';
import { uploadFile, enhancePrompt, generateVideo, enhancePromptVariation } from "../../services/apiService";
import ErrorPopup from "../Popup/ErrorPopup/ErrorPopup";
import LoaderWithBackdrop from "../Loader/loader";
import { showToast } from "../Toast/CommonToast";
import { getModelName } from "../../services/apiService";
import {useVideoWebSocket} from "../../context/VideoWebSocket";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import Popup from "../Popup/GalleyPopup";
import ExistingUploadImages from "../ExistingImageContainer/ExistingUploadImages";
import { useCreditPoints } from "../../services/CreditPointsProvider";
import ReusableButton from "../Reusable/PrimaryButton/PrimaryButton";

interface VideoComponentProps {
    value?: number;
    image?: string | null;
    setImage?: (value: string | null) => void;
    setUploadFile?: (value: any) => void;
    uploadfile?: any;
    prompt?: string;
    setPrompt?: (value: string) => void;
    setVideoData?: (value: any) => void;
    videoData?: any;
    setOpenPopover?: (value: boolean) => void | undefined;
    openPopover?: boolean;
}
interface imageId {
    _id: string;
    url: string;
    caption: string;
    inputData?: {
        prompt?: string;
    };
    usedPrompt?: string; // Added to handle the used prompt
}



export default function UploadImages({ value, image, setImage, setUploadFile, uploadfile, prompt, setPrompt, videoData, setVideoData, setOpenPopover, openPopover }: VideoComponentProps) {
    const [errorPopupOpen, setErrorPopupOpen] = useState({ open: false, message: "" });
    const modelId = "67ed04b99104e4df3945139c";
    const userId = localStorage.getItem("userId") || "userId";
    const [loading, setLoading] = useState(false);
    const [eventId, setEventId] = React.useState<any>("");
    const [openModel, setOpenModel] = useState<boolean>(false);
    const [selectionMode, setSelectionMode] = useState<'card' | 'image'>('card');
  const [selectedImageId, setSelectedImageId] = useState<imageId | null>(null);
  const { fetchCreditPoints} = useCreditPoints();

  useEffect(()=>{
    if(selectedImageId){
        setPrompt?.(selectedImageId?.inputData?.prompt || selectedImageId?.usedPrompt || "");
        setImage?.(selectedImageId?.url || "");
    }
  },[selectedImageId, setPrompt, setImage]);

    const [count, setCount] = useState(1);
    const fileInputRef = useRef(null);
    const {reconnectWebSocket} = useVideoWebSocket();

    const handleButtonClick = () => {
        if (fileInputRef.current) {
            (fileInputRef.current as any).click();
        }
    };

    const modelNames = async()=>{
        const mediaType = "video"
  
        try{
          const modelNameResponse = await getModelName(mediaType);
          setEventId(modelNameResponse?.data);
        }catch(error){
          console.error("Error fetching model name:", error);
        }
      }
  
      React.useEffect(()=>{
        modelNames();
      },[])

    const eventIdRes = Array.isArray(eventId)
    ? eventId.find((item: any) => item?.eventName === "Cinemotion")?._id
    : null;
    localStorage.setItem("eventId", eventIdRes);

    // fileUpload function api calling here
    const handleFileUpload = React.useCallback(
        async (event: React.ChangeEvent<HTMLInputElement>) => {
            const files = event.target.files;
            if (files) {
                const formData = new FormData();
                Array.from(files).forEach((file, index) => {
                    formData.append("files", file);
                });
                formData.append("userId", userId);
                formData.append("isStudioImage", "true");
                formData.append("eventId", eventIdRes);
                setLoading(true);
                try {
                    const uploadFileResponse = await uploadFile(formData);
                    setLoading(false);
                    if (uploadFileResponse.status === "success") {
                        showToast(uploadFileResponse.message, "success");
                        setUploadFile?.(uploadFileResponse.data[0]);
                        setPrompt?.(uploadFileResponse.data[0].caption);
                        setImage?.(uploadFileResponse.data[0].url);
                    }else{
                        showToast(uploadFileResponse.message, "error");
                    }
                } catch (error: any) {
                    showToast(error?.message, "error");
                    setLoading(false);
                    console.error("Error uploading files", error);
                }
            }
        },
        [userId, eventIdRes, setUploadFile, setPrompt, setImage]
    );

    
  // Auto-upload when selectedImageId?.url is present
  useEffect(() => {
    const uploadImageFromUrl = async () => {
      if (selectedImageId?.url) {
        try {
          const response = await fetch(selectedImageId.url);
          const blob = await response.blob();
          const urlParts = selectedImageId.url.split('.');
          const ext = urlParts.length > 1 ? urlParts[urlParts.length - 1].split('?')[0] : 'jpg';
          const fileName = `selectedImage.${ext}`;
          const fileFromUrl = new File([blob], fileName, { type: blob.type });
          // Create a synthetic event
          const syntheticEvent = {
            target: {
              files: [fileFromUrl]
            }
          } as unknown as React.ChangeEvent<HTMLInputElement>;
          handleFileUpload(syntheticEvent);
        } catch (error) {
          showToast('Failed to upload image from URL', 'error');
        }
      }
    };
    if (selectedImageId?.url) {
      uploadImageFromUrl();
    }
    // Only run when selectedImageId?.url changes
  }, [selectedImageId?.url, handleFileUpload]);
    // handlePromptChange function
    const handlePromptChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        setPrompt?.(value);
    }

    //   Enhance with AI function
    const handleEnhanceWithAI = async () => {
        setLoading(true);
        const payLoadPrompt = {
            prompt: prompt,
            eventId: eventIdRes,
        }
        const enhancePromptResponse = await enhancePrompt(payLoadPrompt);
        setLoading(false);
        if (enhancePromptResponse.status === "success") {
            setPrompt?.(enhancePromptResponse.data);
        }
    }
       const handleVariationWithAI = async () => {
            setLoading(true);
            try {
                const payloadVariation = {
                    prompt: prompt,
                    eventId: eventIdRes,
                    imageUrl: image ? image : selectedImageId?.url || ""
                }
                const response = await enhancePromptVariation(payloadVariation);
                setLoading(false);
                if (response && response.status === "success") {
                       if (selectedImageId) {
                        setSelectedImageId({
                            ...selectedImageId,
                            usedPrompt: response.data,
                            inputData: {
                                ...selectedImageId.inputData,
                                prompt: response.data
                            }
                        });
                    } else {
                          setPrompt?.(response.data);
                    }
                    showToast(response.message, "success");
                } else {
                    showToast(response.message, "error");
                    setLoading(false);
                }
            } catch (error: any) {
                setLoading(false);
                showToast(error.message, "error");
            }
        };
    const creditPonints = eventId && eventId.find((item: any) => item?.eventName === "Cinemotion")?.creditPoints;
    // Video generation function
    const handleGenerateVideo = async () => {
        reconnectWebSocket(); //reconnect the socket again
        const payLoadVideo = {
            imageUrl: image,
            prompt: prompt,
            modelId: modelId,
            userId: userId,
            eventId: eventIdRes,
            creditsPoints: creditPonints,
        };
        setLoading(true);

        try {
            const response = await generateVideo(payLoadVideo);
            setLoading(false);
            fetchCreditPoints(userId);
            const is404 = response?.statusCode === 404  || response?.errcode === "CRD404";
            const is403 = response?.statusCode === 403  || response?.errcode === "CRD403";
            if (response?.status === "success") {
                setVideoData?.(response?.data);
                setPrompt?.("");
                setImage?.("");
                setSelectedImageId?.(null);
            } else if (is404 || is403 || response?.errcode) {
                setErrorPopupOpen({
                    open: true,
                    message: response?.message || "Failed to generate video.",
                });
            } else {
                showToast(response?.message || "Failed to generate video.", "error");
            }
        } catch (error:any) {
            setLoading(false);
            showToast(error?.message || "Failed to generate video.", "error");
            setErrorPopupOpen({
                open: true,
                message: error?.message || "Failed to generate video.",
            });
        }
    };



    // remove image function
    const handleRemove = () => {
        setImage?.("");
        setPrompt?.("");
        setSelectedImageId?.(null);
    }
     const handleGalleryImage = () => {
        setOpenModel(true);
        setSelectionMode('card');
        setSelectedImageId(null);
    }



    return (
        <Grid className="uploadImageContainer">
            {loading && <LoaderWithBackdrop open={loading} />}
            {(errorPopupOpen.open && (errorPopupOpen.message === "Credits not found" || errorPopupOpen.message === "Insufficient credits")) && (
                <ErrorPopup
                    open={errorPopupOpen.open}
                    message={errorPopupOpen.message}
                    onClose={() => setErrorPopupOpen({ open: false, message: "" })}
                />
            )}
            <Box>

                    <div className="uploadTextContainer">
                        <Typography variant="body1" className="fromUploadText">upload your Source Image</Typography>
                        {/* <img src={UploadAdd} alt="UploadAdd" className="uploadAddIcon" onClick={handleButtonClick} /> */}
                    </div>
                

                                        <Card
                                            className="UploadCard"
                                            onDrop={async (e) => {
                                                e.preventDefault();
                                                try {
                                                    const data = e.dataTransfer.getData('application/json');
                                                    if (data) {
                                                        const image = JSON.parse(data);
                                                        setSelectedImageId?.(image);
                                                        setImage?.(image.url);
                                                        setPrompt?.(image.caption || '');
                                                    }
                                                } catch (err) {
                                                    // ignore
                                                }
                                            }}
                                            onDragOver={e => e.preventDefault()}
                                        >
                                                {(selectedImageId?.url || image) ? (
                                                        <>
                                                                <img src={selectedImageId?.url || image || ""} alt="Uploaded" style={{ width: '70%', height: '100%', objectFit: "contain" }} />
                                                                <img src={'/assets/Deletedicon.svg'} alt="DeletedIcon" className="DeletedIcon" onClick={handleRemove} />
                                                        </>
                                                ) : (
                                                        <Box className="uploadBox">
                                                                <div>
                                                                        <img src={'/assets/UploadIcon.svg'} alt="Upload Icon" className="uploadIcon" onClick={handleButtonClick}/>
                                                                        <Typography className="uploadText">Upload Image From</Typography>
                                                                        <div className="containerbtn">
                                                                                <ButtonComponent onClick={handleButtonClick} >Computer</ButtonComponent>
                                                                                <ButtonComponent className="nonStyledbtn" onClick={handleGalleryImage} >Persona</ButtonComponent>
                                                                        </div>
                                                                        {/* Hidden file input */}
                                                                        <input
                                                                                type="file"
                                                                                ref={fileInputRef}
                                                                                style={{ display: "none" }}
                                                                                accept="image/*"
                                                                                onChange={handleFileUpload}
                                                                                multiple={false}
                                                                        />

                                                                </div>

                                                        </Box>
                                                )}
                                        </Card>

                <Card className="promptCard">
                    <Box className="promptBox">
                        <div className="promptImageContainer">
                            <span className="promptImageWrapper">
                                <img src={promptMessage} alt='prompt' className='promptImage' />
                                <Typography variant="body1" className="promptText">
                                    Write a prompt
                                </Typography>
                            </span>
                            <ReusableButton icon={<AutoAwesomeIcon className="variationIcon" />} onClick={handleVariationWithAI} disabled={!prompt || !image }>Variant with AI</ReusableButton>
                            <ButtonComponent onClick={handleEnhanceWithAI} disabled={!prompt || !image} icon={<AutoAwesomeIcon className="enhanceIcon" />}>
                                Enhance with AI
                            </ButtonComponent>
                        </div>

                      
              <div>
                  <TextField
                    placeholder="Write Here..."
                    multiline
                    minRows={prompt ? 3 : 5}
                    maxRows={prompt? 3 : 5}
                    variant="outlined"
                    className="textField"
                    value={prompt || ""}
                    onChange={handlePromptChange}
                  />
              </div>
                    </Box>
                </Card>

                <Card className="countCard">
                    <Grid className="countGrid">
                        <Box className="countContainer">
                            <Typography className="countText">{count}</Typography>
                            <Box className="buttonContainer">
                                <Button
                                  onClick={() => setCount((prev) => Math.min(prev + 1, 5))}
                                    variant="contained"
                                    className="countButton"
                                >
                                    +
                                </Button>
                                <Button
                                     onClick={() => setCount((prev) => Math.max(prev - 1, 1))}
                                    variant="contained"
                                    className="countButton"
                                >
                                    -
                                </Button>
                            </Box>
                        </Box>
                        <Box>
                            <ButtonComponent onClick={handleGenerateVideo}
                            disabled={!image || !prompt} 
                            >
                            Generate (300 credits)</ButtonComponent>
                        </Box>
                    </Grid>
                </Card>
                <Box className="cinemotion-upload">
                    <ExistingUploadImages modelId={eventIdRes} setImage={setImage} setPrompt={setPrompt}  image={image}/>
                </Box>
              {openModel && (
                <Popup
                open={openModel}
                onClose={() => setOpenModel(false)}
                selectionMode={selectionMode}
                setSelectionMode={setSelectionMode}
                setSelectedImageId={setSelectedImageId}
                selectedImageId={selectedImageId}
                 />
            )}
            </Box>
        </Grid>

    )
}